import React, { useEffect } from "react";
import { LoginForm } from "../Components/custom/LoginForm";
import { Box } from "@chakra-ui/react";
import { setDynamicTitle } from "../Utils/dynamicTitleManager";

export const Login = () => {
  // Use dynamic title management
  useEffect(() => {
    setDynamicTitle("Login");
  }, []);

  return (
    <>
      <Box
        width="100%"
        minHeight="100vh"
        px={4}
        display="flex"
        justifyContent="center"
        alignItems="center"
      >
        <LoginForm />
      </Box>
    </>
  );
};